import { createSlice } from "@reduxjs/toolkit";

export const coeSlice = createSlice({
  name: "coeSlice",
  initialState: {
    subscribeBox: false,
    unregisterBox: false,
    requestListBox: false,
    transferEmailBox: false,
    boxShowing: false,
    selectedInmate: "",
  },
  reducers: {
    showSubscribeBox: (state) => {
      state.subscribeBox = true;
      state.boxShowing = true;
    },
    hideSubscribeBox: (state) => {
      state.subscribeBox = false;
      state.boxShowing = false;
    },
    showUnregisterBox: (state) => {
      state.unregisterBox = true;
      state.boxShowing = true;
    },
    hideUnregisterBox: (state) => {
      state.unregisterBox = false;
      state.boxShowing = false;
    },
    showRequestListBox: (state) => {
      state.requestListBox = true;
      state.boxShowing = true;
    },
    hideRequestListBox: (state) => {
      state.requestListBox = false;
      state.boxShowing = false;
    },
    showTransferEmailBox: (state) => {
      state.transferEmailBox = true;
      state.boxShowing = true;
    },
    hideTransferEmailBox: (state) => {
      state.transferEmailBox = false;
      state.boxShowing = false;
    },
    setSelectedInmate: (state, action) => {
      state.selectedInmate = action.payload;
    },
  },
});

export const {
  showSubscribeBox,
  hideSubscribeBox,
  showUnregisterBox,
  hideUnregisterBox,
  showRequestListBox,
  hideRequestListBox,
  showTransferEmailBox,
  hideTransferEmailBox,
  setSelectedInmate,
} = coeSlice.actions;
export default coeSlice.reducer;
